import { render, staticRenderFns } from "./FullRequestLogs.vue?vue&type=template&id=bc021568&"
import script from "./FullRequestLogs.vue?vue&type=script&lang=js&"
export * from "./FullRequestLogs.vue?vue&type=script&lang=js&"
import style0 from "./FullRequestLogs.vue?vue&type=style&index=0&id=bc021568&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/FullRequestLogs.vue
// module id = null
// module chunks = 